<template>
  <b-container fluid>
    <b-row align-v="center" class="form-login-bg" style="height: 100vh">
      <b-col cols="12" md="5" class="d-block">
        <b-row align-h="center">
          <b-col md="5" sm="8" cols="10">
            <div class="mb-6 position-relative">
              <b-row align-v="center">
                <b-col class="text-center">
                  <div>
                    <img src="../assets/logo/kmitl-go.png" width="120" class="img-fluid">
                  </div>
                </b-col>
                <b-col class="text-center">
                  <div class="logo-bg text-center">
                    <img src="../assets/logo/kmitl-osda.png" width="120" class="img-fluid">
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="pt-3">
              <h1>ลงชื่อเข้าสู่ระบบ</h1>
              <b-form-group>
                <b-form-input v-model="form.username" placeholder="Username" @keydown.enter="login" />
              </b-form-group>
              <b-form-group>
                <b-form-input v-model="form.password" type="password" placeholder="Password" @keydown.enter="login" />
              </b-form-group>
              <b-button squared variant="orange" block @click="login">
                {{ textButton }}
                <b-spinner v-if="loginLoading" small />
              </b-button>
            </div>
            <div v-if="error" class="row alert">
              <div class="col-md-12">
                <b-alert :show="error" variant="danger" dismissible @dismissed="error = false">
                  <span>ไม่สามารถเข้าสู่ระบบได้ ตรวจสอบชื่อผู้ใช้และรหัสผ่านอีกครั้ง</span>
                </b-alert>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="7" class="login-bg d-none d-md-block" />
    </b-row>
  </b-container>
</template>

<script>
export default {
  data () {
    return {
      form: {
        username: '',
        password: ''
      },
      textButton: 'เข้าสู่ระบบ',
      error: false,
      loginLoading: false
    }
  },
  methods: {
    login () {
      this.error = false
      this.loginLoading = true
      this.textButton = 'กำลังเข้าสู่ระบบ...'
      this.$auth.login({ data: this.form }).catch(e => {
        this.error = true
        this.loginLoading = false
        this.textButton = 'เข้าสู่ระบบ'
      })
    }
  }
}
</script>

<style scoped lang="scss">

  .form-control {
    border-radius: 0 !important;
  }

  .btn-orange {
    background: #e35205;
    color: #ffffff;
    &:hover {
      color: #ffffff;
    }
  }

  .form-login-bg {
    background: #e8e8e8;
  }

  .logo-bg {
    background: #e35205;
    max-width: 120px;
    max-height: 120px;
  }

  .login-bg {
    background-image: url("../assets/login-bf.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
  }

  h1 {
    font-size: $font-size-lg * 1.2;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }

  .alert {
    position: absolute;
    z-index: 2;
    width: 450px;
    left: -45px;
  }
</style>
